import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-company" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__filter" }
const _hoisted_4 = {
  key: 0,
  class: "header__stats"
}
const _hoisted_5 = {
  key: 1,
  class: "header__info"
}
const _hoisted_6 = { class: "capsule" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "action" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "new-modal" }
const _hoisted_16 = { class: "description__footer" }
const _hoisted_17 = { class: "new-modal" }
const _hoisted_18 = { class: "auto-complete" }
const _hoisted_19 = { class: "description__footer" }

import {
  InfoCircle,
  SearchMd,
  Lock01,
  LockUnlocked01,
  Truck02,
} from "utruckin-icons";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { useTeamStore } from "@/features/teams/team.store";
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { ITeam } from "@/features/teams/team.types";
import { DateTime } from "luxon";
import { useCompanyStore } from "@/features/company/company.store";
import { ICompany } from "@/features/company/company.types";
import CommonButton from "@/components/common/CommonButton.vue";
import CustomTableDropdown from "@/components/custom/CustomTableDropdown.vue";
import { useAppStore } from "@/store/app.store";
import { useProvidersStore } from "@/features/providers/providers.store";
import { IProvider } from "@/features/providers/providers.types";
import CustomTab from "@/components/custom/CustomTab.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useNotification } from "@/utils/notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyView',
  setup(__props) {

const teamStore = useTeamStore();
const companyStore = useCompanyStore();
const providerStore = useProvidersStore();
const appStore = useAppStore();

const { pushNotification } = useNotification();

const teams = ref<ITeam[]>([]);
const team = ref<string | null>(null);
const provider = ref<string | null>(null);
const companyLoading = ref(false);
const teamLoading = ref(false);
const providerLoading = ref(false);
const search = ref<string>("");
const setTeam = ref<string | null>(null);
const selectedItems = ref([]);
const providers = ref<IProvider[]>([]);
const companyTable = ref();
const companies = ref<ICompany[]>([]);
const activeTab = ref<number>(0);
const tabs = [
  { label: "All", value: 0 },
  { label: "With team", value: 1 },
  { label: "No team", value: 2 },
];

const isOpenModal = ref<boolean>(false);
const note = ref<string>("");
const modalItem = ref<ICompany | null>(null);

const reason = ref<string>("");
const lockModalItem = ref<any>();
const lockModal = ref<boolean>(false);
const lockModalLoading = ref<boolean>(false);

let searchTimer: ReturnType<typeof setTimeout> | null = null;

const teamItems = computed(() =>
  teams.value.map((t) => ({ value: t.id, name: t.name }))
);

const providerItems = computed(() =>
  providers.value.map((t) => ({ value: t.id, name: t.name }))
);

const openModal = (item: ICompany) => {
  modalItem.value = item;
  isOpenModal.value = true;
  note.value = item.note;
};

const closeModal = () => {
  modalItem.value = null;
  isOpenModal.value = false;
  note.value = "";
};

const saveModal = async () => {
  if (!modalItem.value) return;

  await companyStore.addCompanyNote(
    companyLoading,
    modalItem.value.id,
    { note: note.value },
    async (data: any) => {
      if (data) {
        pushNotification("Successfully saved", "success");
        closeModal();
        await getList();
      }
    }
  );
};

const updateTeam = async (item: ICompany, value: string) => {
  const rowId = item.id;
  item.team_id = value;
  const data = await companyStore.updateCompany(companyLoading, item.id, {
    team_id: value as string,
  });
  if (data) {
    await getList();
  }
  companyTable.value?.scrollToRow(rowId);
};

function datepickerToUtcDateOnly(d: Date | null | undefined) {
  return DateTime.fromISO(d, {
    zone: "utc",
  })
    .setZone("America/New_York")
    .toFormat("yyyy-MM-dd");
}

const getList = async () => {
  [teams.value, companies.value, providers.value] = await Promise.all([
    teamStore.getTeams(teamLoading),
    companyStore.getCompanies(companyLoading),
    providerStore.getProviders(providerLoading),
  ]);
};

const updateAllTeam = async () => {
  let company_ids: string[] = [];

  selectedItems.value.forEach((item: ICompany) => {
    company_ids.push(item.id);
  });

  let result = {
    company_ids: company_ids,
    team_id: setTeam.value as string,
  };
  const data = await companyStore.bulkUpdateCompany(teamLoading, result);

  if (data) {
    window.location.reload();
  }
};

const unlock = async (item: ICompany) => {
  await companyStore.taskCreationBlock(
    lockModalLoading,
    item.id,
    {
      reason: item.task_creation_blocked_reason,
      is_task_creation_blocked: false,
    },
    async (data: any) => {
      if (data) {
        pushNotification("Successfully unlocked", "success");
        await getList();
      }
    }
  );
};

const blockItem = (item: ICompany) => {
  lockModal.value = true;
  lockModalItem.value = item;
  reason.value = "";
};

const closeLockModal = () => {
  lockModalItem.value = null;
  lockModal.value = false;
  reason.value = "";
};

const saveLockModal = async () => {
  if (!lockModalItem.value) return;

  await companyStore.taskCreationBlock(
    lockModalLoading,
    lockModalItem.value.id,
    {
      reason: reason.value,
      is_task_creation_blocked: true,
    },
    async (data: any) => {
      if (data) {
        pushNotification("Successfully locked", "success");
        closeLockModal();
        await getList();
      }
    }
  );
};

const deactivateTruck = async (item: any) => {
  if (companyLoading.value) return;

  await companyStore.truckDeactivation(
    companyLoading,
    item.id,
    {
      truck_deactivation_enabled: !item.truck_deactivation_enabled,
    },
    async (data: any) => {
      if (data) {
        pushNotification("Successfully saved", "success");
        await getList();
      }
    }
  );
};

onMounted(() => {
  companyStore.commonFilter.team_id = "";

  getList();
  if (companyStore.commonFilter?.has_team == null) {
    activeTab.value = 0;
  } else if (companyStore.commonFilter?.has_team) {
    activeTab.value = 1;
  } else {
    activeTab.value = 2;
  }
});

onUnmounted(() => {
  companyStore.clearFilter();
});

watch(search, (val) => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(async () => {
    companyStore.commonFilter.search = val;
    await getList();
  }, 400);
});

watch(team, async (val) => {
  companyStore.commonFilter.team_id = val as string;
  await getList();
});

watch(provider, async (val) => {
  companyStore.commonFilter.provider_id = val as string;
  await getList();
});

watch(
  () => activeTab.value,
  async (newVal) => {
    if (companyStore.commonFilter) {
      if (newVal == 0) {
        companyStore.commonFilter.has_team = null;
      } else companyStore.commonFilter.has_team = newVal == 1;

      await getList();
    }
  }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CommonSearch, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          icon: _unref(SearchMd),
          placeholder: "Search",
          clearable: "",
          disabled: selectedItems.value.length > 0
        }, null, 8, ["modelValue", "icon", "disabled"]),
        _createVNode(CommonDropdown, {
          modelValue: team.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((team).value = $event)),
          items: teamItems.value,
          label: "Team",
          clearable: "",
          disabled: selectedItems.value.length > 0
        }, null, 8, ["modelValue", "items", "disabled"]),
        _createVNode(CommonDropdown, {
          modelValue: provider.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((provider).value = $event)),
          items: providerItems.value,
          label: "App name",
          clearable: "",
          disabled: selectedItems.value.length > 0
        }, null, 8, ["modelValue", "items", "disabled"]),
        _createVNode(CustomTab, {
          tabs: tabs,
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((activeTab).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      (selectedItems.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(CommonDropdown, {
              modelValue: setTeam.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((setTeam).value = $event)),
              items: teamItems.value,
              label: "Team",
              clearable: ""
            }, null, 8, ["modelValue", "items"]),
            _createVNode(CommonButton, {
              onClick: updateAllTeam,
              type: "primary",
              label: "Save"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label" }, "All truck", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(companies.value.active_trucks_summary?.total), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companies.value.active_trucks_summary?.by_team, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "capsule",
                key: index
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.team_name), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.active_trucks), 1)
              ]))
            }), 128))
          ]))
    ]),
    _createVNode(CommonTable, {
      ref_key: "companyTable",
      ref: companyTable,
      headers: _unref(companyStore).companyHeaders,
      loading: companyLoading.value,
      items: companies.value.items,
      selected: selectedItems.value,
      "onUpdate:selected": _cache[5] || (_cache[5] = ($event: any) => ((selectedItems).value = $event)),
      selectMode: ""
    }, {
      id: _withCtx(({ index }) => [
        _createElementVNode("span", null, _toDisplayString(index + 1), 1)
      ]),
      created_time: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(datepickerToUtcDateOnly(item.created_time)), 1)
      ]),
      team: _withCtx(({ item }) => [
        _createVNode(CustomTableDropdown, {
          "model-value": item.team_id,
          "onUpdate:modelValue": (value) => updateTeam(item, value),
          items: teamItems.value,
          label: "Team",
          position: "bottom",
          clearable: "",
          disabled: selectedItems.value.length > 0
        }, null, 8, ["model-value", "onUpdate:modelValue", "items", "disabled"])
      ]),
      actions: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "action__item",
            onClick: ($event: any) => (openModal(item))
          }, [
            _createVNode(_unref(InfoCircle), { size: 18 })
          ], 8, _hoisted_11)), [
            [_directive_tooltip, {
              content: 'Comment',
              html: true,
            }]
          ]),
          (item.is_task_creation_blocked)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "action__item unlock",
                onClick: ($event: any) => (unlock(item))
              }, [
                _createVNode(_unref(LockUnlocked01), { size: 18 })
              ], 8, _hoisted_12)), [
                [_directive_tooltip, {
              content: item.task_creation_blocked_reason,
              html: true,
            }]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "action__item lock",
                onClick: ($event: any) => (blockItem(item))
              }, [
                _createVNode(_unref(Lock01), { size: 18 })
              ], 8, _hoisted_13)), [
                [_directive_tooltip, {
              content: 'Lock',
              html: true,
            }]
              ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["action__item", item.truck_deactivation_enabled ? '' : 'unlock']),
            onClick: ($event: any) => (deactivateTruck(item))
          }, [
            _createVNode(_unref(Truck02), { size: 18 })
          ], 10, _hoisted_14)), [
            [_directive_tooltip, {
              content: item.truck_deactivation_enabled
                ? 'Truck deactivation enabled'
                : 'Truck deactivation disabled',
              html: true,
            }]
          ])
        ])
      ]),
      _: 1
    }, 8, ["headers", "loading", "items", "selected"]),
    _createVNode(CommonModal, {
      modelValue: isOpenModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isOpenModal).value = $event)),
      title: "Company note"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(CommonInput, {
            modelValue: note.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((note).value = $event)),
            label: "Note",
            multiline: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: lockModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((lockModal).value = $event)),
      title: "Block task creation"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeLockModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveLockModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(CommonInput, {
            modelValue: reason.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((reason).value = $event)),
            label: "Reason",
            multiline: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (reason.value = 'Payment overdue'))
          }, " Payment overdue "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (reason.value = 'No edit'))
          }, "No edit"),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (reason.value = 'Left our service'))
          }, " Left our service ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})